import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="payment-methods"
export default class extends Controller {
  static targets = ["addCardForm", "submitButton", "submitText", "submitSpinner", "errorDisplay", "errorMessage"]
  static values = {
    stripePublishableKey: String,
    setupClientSecret: String
  }

  connect() {
    console.log("Payment methods controller connected")

    if (this.hasSetupClientSecretValue && this.stripePublishableKeyValue) {
      this.initializeStripe()
    }
  }

  initializeStripe() {
    this.stripe = Stripe(this.stripePublishableKeyValue)

    // Create Payment Element
    this.elements = this.stripe.elements({
      clientSecret: this.setupClientSecretValue,
      appearance: {
        theme: 'stripe',
        variables: {
          colorPrimary: getComputedStyle(document.documentElement).getPropertyValue('--accent-color').trim() || '#0f8b8d',
        }
      }
    })

    this.paymentElement = this.elements.create('payment')
  }

  toggleAddCardForm() {
    const isHidden = this.addCardFormTarget.classList.contains('hidden')

    this.addCardFormTarget.classList.toggle('hidden')

    // Mount Payment Element when form is shown
    if (isHidden && this.paymentElement) {
      setTimeout(() => {
        this.paymentElement.mount('#stripe-payment-element')
      }, 100)
    }
  }

  async handleSubmit(event) {
    event.preventDefault()

    // Disable submit button
    this.submitButtonTarget.disabled = true
    this.submitTextTarget.classList.add('hidden')
    this.submitSpinnerTarget.classList.remove('hidden')

    try {
      // Confirm the SetupIntent
      const { setupIntent, error } = await this.stripe.confirmSetup({
        elements: this.elements,
        redirect: 'if_required'
      })

      if (error) {
        // Show error
        this.showError(error.message)
        this.resetSubmitButton()
      } else if (setupIntent.status === 'succeeded') {
        // Success - submit the form with the SetupIntent ID
        const setupIntentIdInput = event.target.querySelector('#setup_intent_id')
        setupIntentIdInput.value = setupIntent.id
        event.target.submit()
      }
    } catch (err) {
      console.error('Setup error:', err)
      this.showError('An unexpected error occurred. Please try again.')
      this.resetSubmitButton()
    }
  }

  showError(message) {
    if (this.hasErrorDisplayTarget && this.hasErrorMessageTarget) {
      this.errorDisplayTarget.classList.remove('hidden')
      this.errorMessageTarget.textContent = message
    }
  }

  resetSubmitButton() {
    this.submitButtonTarget.disabled = false
    this.submitTextTarget.classList.remove('hidden')
    this.submitSpinnerTarget.classList.add('hidden')
  }
}
